import React from 'react';
import AudioLevelIndicator from '../AudioLevelIndicator/AudioLevelIndicator';
import ParticipantConnectionIndicator from './ParticipantConnectionIndicator/ParticipantConnectionIndicator';
import PinIcon from './PinIcon/PinIcon';
import usePublications from '../../../src/hooks/usePublications/usePublications';
import useTrack from '../../../src/hooks/useTrack/useTrack';
import { luxColors } from '@alucio/lux-ui';
const useStyles = {
    audioLevelContainer: {
        paddingRight: 4,
        paddingLeft: 4,
    },
    controlsContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    container: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        cursor: 'pointer',
        backgroundColor: luxColors.contentPanelBackground.primary,
    },
    isVideoSwitchedOff: {
    /* '& video': {
      filter: 'blur(4px) grayscale(1) brightness(0.5)',
    }, */
    },
    infoContainer: {
        position: 'absolute',
        zIndex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        padding: '0.4em',
        paddingLeft: 0,
        width: '100%',
    },
    hideVideo: {
        background: 'black',
    },
    identity: {
        color: luxColors.info.primary,
        padding: '0.1em 0.3em',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        fontSize: 12,
        fontWeight: 500,
        // eslint-disable-next-line max-len
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Ubuntu, "Helvetica Neue", sans-serif',
    },
    infoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        height: '100%',
        alignItems: 'flex-end',
    },
    infoRowContainer: {
        backgroundColor: luxColors.opacityBackground.darker,
        display: 'flex',
        paddingRight: 6,
        paddingBottom: 3,
        paddingTop: 3,
        height: 20,
    },
    title: {
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        maxWidth: 170,
        paddingLeft: 6,
    },
};
function ParticipantInfo({ participant, phoneParticipant, name, onClick, isSelected, children, menu, }) {
    if (!participant) {
        return null;
    }
    const publications = usePublications(participant);
    const phonePublications = usePublications(phoneParticipant !== null && phoneParticipant !== void 0 ? phoneParticipant : participant);
    const audioPublication = (phoneParticipant ? phonePublications : publications).find(p => p.kind === 'audio');
    // const videoTrack = useTrack(videoPublication) as LocalVideoTrack | RemoteVideoTrack;
    // const isVideoSwitchedOff = useIsTrackSwitchedOff(videoTrack as LocalVideoTrack | RemoteVideoTrack);
    const audioTrack = useTrack(audioPublication);
    const classes = useStyles;
    return (React.createElement("div", { 
        // @ts-ignore
        style: classes.container, onClick: onClick, "data-cy-participant": name },
        React.createElement("div", { 
            // @ts-ignore
            style: classes.infoContainer },
            menu,
            React.createElement("div", { style: classes.infoRow },
                React.createElement("div", { 
                    // @ts-ignore
                    style: classes.infoRowContainer },
                    React.createElement("div", { style: classes.controlsContainer },
                        React.createElement("div", { style: classes.audioLevelContainer },
                            React.createElement(AudioLevelIndicator, { participant: participant, audioTrack: audioTrack, isPhoneAudio: Boolean(phoneParticipant) }))),
                    React.createElement("h4", { style: classes.identity },
                        React.createElement(ParticipantConnectionIndicator, { participant: participant }),
                        React.createElement("div", { 
                            // @ts-expect-error
                            style: classes.title }, name)))),
            React.createElement("div", null, isSelected && React.createElement(PinIcon, null))),
        children));
}
export default React.memo(ParticipantInfo);
//# sourceMappingURL=ParticipantInfo.js.map